import { Routes } from '@angular/router';
import { ProductsListComponent } from './products/products-list/products-list.component';
import { TempProductsListComponent } from './products/temp-products-list/temp-products-list.component';
import { AuthComponent } from './auth/auth.component';
import { RekbotsListComponent } from './rekbots/rekbots-list/rekbots-list.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { RekbotInfoComponent } from './rekbots/rekbot-layout/rekbot-info/rekbot-info.component';
import { UserComponent } from './users/user/user.component';
import { UserProfileComponent } from './users/user-profile/user-profile.component';
import { RekbotSettingsComponent } from './rekbots/rekbot-layout/rekbot-settings/rekbot-settings.component';
import { RekbotSettingsEmailListComponent } from './rekbots/rekbot-settings-email-list/rekbot-settings-email-list.component';
import { SettingsSmtpListComponent } from './settings/settings-smtp-list/settings-smtp-list.component';
import { EmailConfigListComponent } from './rekbots/email-config-list/email-config-list.component';
import { ReceiptCreatorComponent } from './receipts/receipt-creator/receipt-creator.component';
import { UserRekbotsComponent } from './users/user-rekbots/user-rekbots.component';
import { MainScreenComponent } from './main-screen/main-screen.component';
import { OrganizationsListComponent } from './organizations/organizations-list/organizations-list.component';
import { OrganizationComponent } from './organizations/organization/organization.component';
import { CreateOrganizationComponent } from './organizations/create-organization/create-organization.component';
import { EditOrganizationComponent } from './organizations/edit-organization/edit-organization.component';
import { PrivacyPolicyComponent } from './footer/privacy-policy/privacy-policy.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';
import { RegisterUserComponent } from './login-screen/register-user/register-user.component';
import { EditRekbotComponent } from './rekbots/rekbot-layout/edit-rekbot/edit-rekbot.component';
import { AddRekbotComponent } from './rekbots/add-rekbot/add-rekbot.component';
import { ResetPasswordComponent } from './login-screen/reset-password/reset-password.component';
import { ForgetPasswordComponent } from './login-screen/forget-password/forget-password.component';
import { RekbotMapComponent } from './rekbots/rekbot-map/rekbot-map.component';
import { AuthGuard } from './guards/auth.guard';
import { ServiceCardsComponent } from './cards/service-cards/service-cards.component';
import { IntegrationsComponent } from './integrations/integrations/integrations.component';
import { ShowIntegrationComponent } from './integrations/show-integration/show-integration.component';
import { EditIntegrationComponent } from './integrations/edit-integration/edit-integration.component';
import { UserInvitationListComponent } from './users/user-invitation-list/user-invitation-list.component';
import { InvitationInvalidComponent } from './login-screen/invitation-invalid/invitation-invalid.component';
import { registerGuard } from './login-screen/register-user/register.guard';
import { InvitationDetailsComponent } from './users/invitation-details/invitation-details.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RekbotStatusTypeComponent } from './rekbots/rekbot-status-type/rekbot-status-type.component';
import { AdminPermissionGuard } from './guards/adminPremission.guard';
import { RekbotLayoutComponent } from './rekbots/rekbot-layout/rekbot-layout.component';
import { rekbotResolver } from './resolvers/rekbot.resolver';
import { RekbotNotesComponent } from './rekbots/rekbot-layout/rekbot-notes/rekbot-notes.component';
import { RekbotStateService } from './rekbots/rekbot-layout/rekbot-layout-services/rekbot-state.service';
import { RekbotAddNoteComponent } from './rekbots/rekbot-layout/rekbot-notes/rekbot-add-note/rekbot-add-note.component';
import { RekbotViewNoteComponent } from './rekbots/rekbot-layout/rekbot-notes/rekbot-view-note/rekbot-view-note.component';
import { RekbotNoteStateService } from './rekbots/rekbot-layout/rekbot-layout-services/rekbot-note-state.service';
import { RekbotGuard } from './guards/rekbot.guard';

export const routes = [
  // Public sites
  {
    path: '',
    component: AuthComponent,
    title: 'Logowanie',
  },
  {
    path: 'login',
    component: AuthComponent,
    title: 'Logowanie',
  },
  {
    path: 'invitation/accept/:token',
    canActivate: [registerGuard],
    component: RegisterUserComponent,
    title: 'Rejestracja',
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    title: 'Zmiana hasła',
  },
  {
    path: 'forgot-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'invitation-invalid',
    component: InvitationInvalidComponent,
    title: 'Token niewłaściwy',
  },

  //Secure sites
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'main',
        component: MainScreenComponent,
        title: 'Strona główna',
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
        title: 'Profil',
      },
      // {
      //     path: 'temp-products-list',
      //     component: TempProductsListComponent
      // },
      {
        path: 'rekbots-list',
        component: RekbotsListComponent,
        title: 'Maszyny',
      },
      {
        path: 'rekbot/:rekbotId',
        component: RekbotLayoutComponent,
        resolve: {
          rekbot_data: rekbotResolver,
        },
        providers: [RekbotStateService, RekbotNoteStateService],
        children: [
          {
            path: '',
            component: RekbotInfoComponent,
          },
          {
            path: 'edit',
            component: EditRekbotComponent,
            canActivate: [RekbotGuard],
          },
          {
            path: 'location',
            component: RekbotMapComponent,
            // canActivate: [RekbotGuard],
          },
          {
            path: 'settings',
            component: RekbotSettingsComponent,
            canActivate: [RekbotGuard],
          },
          {
            path: 'email-config-list',
            component: EmailConfigListComponent,
            canActivate: [RekbotGuard],
          },
          {
            path: 'notes',
            component: RekbotNotesComponent,
            canActivate: [RekbotGuard],
          },
          {
            path: 'notes/add',
            component: RekbotAddNoteComponent,
            canActivate: [RekbotGuard],
          },
          {
            path: 'notes/show/:noteId',
            component: RekbotViewNoteComponent,
            canActivate: [RekbotGuard],
          },
        ],
      },
      {
        path: 'rekbot-location',
        component: RekbotMapComponent,
      }
    ],
  },
  {
    path: '',
    canActivateChild: [AdminPermissionGuard, AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard',
      },
      {
        path: 'products-list',
        component: ProductsListComponent,
        title: 'Produkty CBDOK',
      },
      {
        path: 'users-list',
        component: UsersListComponent,
        title: 'Użytkownicy',
      },
      {
        path: 'invitation-list',
        component: UserInvitationListComponent,
        title: 'Zaproszenia',
      },
      {
        path: 'invitation/:invitationId',
        component: InvitationDetailsComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'user/:userId',
        component: UserComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'users/edit/:userId',
        component: EditUserComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'user-profile/:userId',
        component: UserProfileComponent,
        // Dynamiczny tytuł w komponencie
      },
      // {
      //     path: 'rekbot-settings-email-list',
      //     component: RekbotSettingsEmailListComponent
      // },
      {
        path: 'settings-smtp-list',
        component: SettingsSmtpListComponent,
        title: 'SMTP',
      },
      {
        path: 'receipt-creator/:rekbotId',
        component: ReceiptCreatorComponent,
        // Dynamiczny tytuł do zmiany układ rekbota
      },
      {
        path: 'user-rekbots/:userId',
        component: UserRekbotsComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'organizations/:organizationId',
        component: OrganizationComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'organizations-list',
        component: OrganizationsListComponent,
        title: 'Etykiety',
      },
      {
        path: 'create-organization',
        component: CreateOrganizationComponent,
        title: 'Dodaj etykietę',
      },
      {
        path: 'edit-organization/:organizationId',
        component: EditOrganizationComponent,
        // Dynamiczny tytuł w komponencie
      },
      {
        path: 'rekbot-status-types',
        component: RekbotStatusTypeComponent,
        title: 'Statusy maszyn',
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        title: 'Polityka prywatności',
      },
      {
        path: 'rekbot-add',
        component: AddRekbotComponent,
      },
      {
        path: 'service-cards',
        children: [
          {
            path: '',
            component: ServiceCardsComponent,
            title: 'Karty serwisowe',
          },
        ],
        // Dynamiczny tytuł w komponencie (w przyszłości)
      },
      {
        path: 'integrations',
        children: [
            {
                path: '',
                component: IntegrationsComponent,
                title: "Integracje"
            },
            {
                path: 'show/:integrationId',
                component: ShowIntegrationComponent
            },
            {
                path: 'edit/:integrationId',
                component: EditIntegrationComponent
            }
                ]
                // Dynamiczny tytuł w komponencie
            },
      ]
    },
    { 
        path: '**',
        redirectTo: ''
    }
]
